import { Box, Typography } from "@mui/material";
import { useTheme } from "../../components/context/context";
import img from '../../assets/imgs/meghalaya-map.jpg'
import BasicTable from "../../components/basicTable/BasicTable";

export default function District() {
    const { fontSize } = useTheme();
    return (
        <Box sx={{}}>
            <Typography variant="h1" sx={{ fontSize: `${fontSize + 0.5}rem`, margin: "5px 0" }}>Districts in Meghalaya</Typography>
            <hr />


            <Box sx={{ padding: "2px 0 2px 10px", marginTop: "20px", width: "100%", textAlign:"justify" }}>
                <div style={{ display: "flex", width: "100%", justifyContent: "center" }}>
                    <img src={img} alt="block map" style={{maxWidth:"100%"}}/>
                </div>
                <br />
                <div style={{ display: "flex", width: "100%", alignItems: "center", flexDirection: "column" }}>
                    Basic Facts of Meghalaya
                    <BasicTable heading={heading2} data={data2} /> {/* Top table */}
                    <p style={{fontSize:`${fontSize}rem`, marginBottom:"0"}}>
                        Tucked away in the hills of eastern sub-Himalayas is Meghalaya, one of the most beautiful State in the country. Nature has blessed her with abundant rainfall,
                        sun-shine, virgin forests, high plateaus, tumbling waterfalls, crystal clear rivers, meandering streamlets and above all with sturdy,
                        intelligent and hospitable people.
                    </p>
                    <p style={{fontSize:`${fontSize}rem`, marginBottom:"0"}}>
                        Emergence of Meghalaya as an Autonomous State on 2nd April 1970 and as a full-fledged State on 21st January 1972 marked the beginning
                        of a new era of the geo-political history of North Eastern India. It also marked the triumph of peaceful democratic negotiations, mutual
                        understanding and victory over violence and intrigue.
                    </p>
                    <p style={{fontSize:`${fontSize}rem`, marginBottom:"0"}}>
                        The State of Meghalaya is situated on the north east of India. It extends for about 300 kilometres in length and about 100 kilometres in
                        breadth. It is bounded on the north by Goalpara, Kamrup and Nowgong districts, on the east by Karbi Anglong and North Cachar Hills
                        districts, all of Assam, and on the south and west by Bangladesh.
                    </p>
                    <p style={{fontSize:`${fontSize}rem`, marginBottom:"10px"}}>
                        Shillong, the capital of Meghalaya is located at an altitude of 1496 metres above sea level. Shillong, which was made Assam's capital in
                        1874, remained so till January 1972, following the formation of Meghalaya. The capital city derives its name from the manifestation of the
                        creator called Shyllong.
                    </p>
                    <BasicTable heading={heading} data={data} /> {/* Table that is displaying all the information in table format */}
                </div>
            </Box>
        </Box>
    )
}
const heading = [ //Heading for each columns
    {
        data: "Sl.No.",
        width: "10%"
    },
    {
        data: "Districts",
        width: "30%"
    },
    {
        data: "District Head Quaters",
        width: "30%"
    },
    {
        data: "Area",
        width: "20%"
    },
    {
        data: "population",
        width: "10%"
    }
]

const data = [//Each array is for each row and each element inside each array is for each column
    ["1", <a rel="noopener noreferrer" href="https://eastgarohills.gov.in/" target="_blank" style={{ color: "black" }}>East Garo Hills</a>, "Williamnagar", "1,490 Sq.km", "13,2257"],
    ["2", <a rel="noopener noreferrer" href="https://eastjaintiahills.gov.in/" target="_blank" style={{ color: "black" }}>East Jaintia Hills</a>, "Khliehriat", "2,115 sq. kms", "1,22,436"],
    ["3", <a rel="noopener noreferrer" href="https://eastkhasihills.gov.in/" target="_blank" style={{ color: "black" }}>East Khasi Hills</a>, "Shillong", "2,748 Sq.km", "824,059"],
    ["4", <a rel="noopener noreferrer" href="https://northgarohills.gov.in/" target="_blank" style={{ color: "black" }}>North Garo Hills</a>, "Resubelpara", "1,113 Sq.km", "118325"],
    ["5", <a rel="noopener noreferrer" href="https://ribhoi.gov.in/" target="_blank" style={{ color: "black" }}>Ri Bhoi</a>, "Nongpoh", "2,378 Sq.km", "25,8840"],
    ["6", <a rel="noopener noreferrer" href="https://southgarohills.gov.in/" target="_blank" style={{ color: "black" }}>South Garo Hills</a>, "Baghmara", "1,887 Sq.km", "1,42,574"],
    ["7", <a rel="noopener noreferrer" href="https://southwestgarohills.gov.in/" target="_blank" style={{ color: "black" }}>South West Garo Hills</a>, "Ampati", "--", "--"],
    ["8", <a rel="noopener noreferrer" href="https://southwestkhasihills.gov.in/" target="_blank" style={{ color: "black" }}>South West Khasi Hills</a>, "Mawkyrwat", "1,341 Sq.km", "1,10,152"],
    ["9", <a rel="noopener noreferrer" href="https://westgarohills.gov.in/" target="_blank" style={{ color: "black" }}>West Garo Hills</a>, "Tura", "3,714 Sq.km", "5,18,390"],
    ["10", <a rel="noopener noreferrer" href="https://westjaintiahills.gov.in/" target="_blank" style={{ color: "black" }}>West Jaintia Hills</a>, "Jowai", "1,693 Sq Kms", "2,70,352"],
    ["11", <a rel="noopener noreferrer" href="https://westkhasihills.gov.in/" target="_blank" style={{ color: "black" }}>West Khasi Hills</a>, "Nongstoin", "5,247 Sq.km", "2,94,115"],
    ["12","Eastern West Khasi Hills", "Mairang", "--", "--"],
]

const heading2 = [
    {
        data: "Location",
        width: "30%",
    },
    {
        data: <div style={{ display: "flex", flexDirection: "column", margin: 0, padding: 0 }}><span>Latitude 20°1' N and 26°5' N</span><span>Longitude 85°49' E and 92°52' E</span></div>,
        width: "70%"
    }
]
const data2 = [
    ['Area', '22,429 Sq. Km.'],
    ['Population', '29,66,889 (As Per 2011 Census)'],
    ['Capital', 'Shillong'],
    ['Districts', '12 (Twelve)'],
    ['C & RD Blocks', '55 (Fifty Five)'],
    ['Literacy', '74.43 %'],
    ['Density', '132 per Sq. Km.'],
]